import './Services.css';
import SideMenu from '../SideMenu';
import ReactGO from '../../images/ReactGO.png';
import HTMLGO from '../../images/HTMLGO.png';
import CSSGO from '../../images/CSSGO.png';
import JSGO from '../../images/JSGO.png';
import TypeScriptGO from '../../images/TypeScriptGO.png';
import GitGO from '../../images/GitGO.png';
import FigmaGO from '../../images/FigmaGO.png';
import VSCodeGO from '../../images/VSCodeGO.png';
import GithubGO from '../../images/GithubGO.png';
import ReactNativeGO from '../../images/ReactNativeGO.png';
import ShopifyGO from '../../images/ShopifyGO.png';
import WordpressGO from '../../images/WordpressGO.png';
import NodeGO from '../../images/nodejsGO.png';


function ServicesContent() {
  return (
    <div className = 'services-content-content'>
      <span className = 'services-content-content-subtitle'>Service</span>
      <span className = 'services-content-content-title'>MY SPECIALTIES</span>
      <div className = 'services-content-content-categories'>
        <div className = 'services-content-content-categories-item'>
          <span className = 'services-content-content-categories-item-title'>• FULL STACK DEVELOPMENT</span>
          <div className = 'services-content-content-categories-item-info'>
            <span className = 'services-content-content-categories-item-info-desc'>I create websites and web applications with the following technologies.</span>
            <div className = 'services-content-content-categories-item-info-images'>
              <img src = {HTMLGO} className = 'services-content-content-categories-item-info-images-img' />
              <img src = {CSSGO} className = 'services-content-content-categories-item-info-images-img' />
              <img src = {JSGO} className = 'services-content-content-categories-item-info-images-img' />
              <img src = {TypeScriptGO} className = 'services-content-content-categories-item-info-images-img' />
              <img src = {ReactGO} className = 'services-content-content-categories-item-info-images-img' />
              <img src = {ReactNativeGO} className = 'services-content-content-categories-item-info-images-img' />
              <img src = {GitGO} className = 'services-content-content-categories-item-info-images-img' />
              <img src = {GithubGO} className = 'services-content-content-categories-item-info-images-img' />
              <img src = {FigmaGO} className = 'services-content-content-categories-item-info-images-img' />
              <img src = {VSCodeGO} className = 'services-content-content-categories-item-info-images-img' />
              <img src = {NodeGO} className = 'services-content-content-categories-item-info-images-img' />
            </div>
          </div>
        </div>
        <div className = 'services-content-content-categories-item'>
          <span className = 'services-content-content-categories-item-title'>• MOBILE APP DEVELOPMENT</span>
          <div className = 'services-content-content-categories-item-info'>
            <span className = 'services-content-content-categories-item-info-desc'>I create mobile applications with the following technologies.</span>
            <div className = 'services-content-content-categories-item-info-images'>
              <img src = {ReactNativeGO} className = 'services-content-content-categories-item-info-images-img' />
              <img src = {CSSGO} className = 'services-content-content-categories-item-info-images-img' />
              <img src = {JSGO} className = 'services-content-content-categories-item-info-images-img' />
              <img src = {GitGO} className = 'services-content-content-categories-item-info-images-img' />
              <img src = {FigmaGO} className = 'services-content-content-categories-item-info-images-img' />
              <img src = {VSCodeGO} className = 'services-content-content-categories-item-info-images-img' />
              <img src = {GithubGO} className = 'services-content-content-categories-item-info-images-img' />
              <img src = {NodeGO} className = 'services-content-content-categories-item-info-images-img' />
            </div>
          </div>
        </div>
        <div className = 'services-content-content-categories-item'>
          <span className = 'services-content-content-categories-item-title'>• CONTENT MANAGEMENT</span>
          <div className = 'services-content-content-categories-item-info'>
            <span className = 'services-content-content-categories-item-info-desc'>I manage web and store content with the following technologies.</span>
            <div className = 'services-content-content-categories-item-info-images'>
              <img src = {ShopifyGO} className = 'services-content-content-categories-item-info-images-img' />
              <img src = {WordpressGO} className = 'services-content-content-categories-item-info-images-img' />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServicesContent;